import $ from "jquery";
import { pathname } from "../../Assets/javascripts/common/others/Configuration";
import { MagnificPopup } from "../../Assets/javascripts/common/dynamic-imports/MagnificPopup";


const magnificPopup = new MagnificPopup();
// All FLY related js must be here

	// Popin modification adresse de livraison FLY
	$('.js-changeDeliveryOrder').on('click', function (e) {
		e.preventDefault();
		magnificPopup.open({
			items: {
				src: $(e.target).siblings('.js-changeDeliveryOrderPopin'),
				type: 'inline'
			}
		});
});

    $('.js-showCancelOrderPopin').on('click', function (e) {
      e.preventDefault();
      magnificPopup.open({
        items: {
          src: $(e.target).siblings('.js-cancelOrder-popup'),
          type: 'inline'
        }
      });
    });


  $(".js-cancelOrder-closePopin").on("click", function (e) {
    magnificPopup.close();
  });

  $(".js-cancelOrder").on("click", function (e) {

    e.preventDefault();
    var currentTarget = $(e.currentTarget);
    var mainOrderRef = currentTarget.attr("data-mainorderref");
    var cancelUrl = `${pathname}/account/api/v1/guestorder/cancel/${mainOrderRef}`;

    $.post({
      url: cancelUrl,
      success: function () {
        $(".js-cancelOrder-content").css("display", "none");
        $(".js-cancelOrder-success").css("display", "block");
      },
      error: function () {
        $(".js-cancelOrder-content").css("display", "none");
        $(".js-cancelOrder-fail").css("display", "block");
      }
    });

  });
